import { render, staticRenderFns } from "./AudioCustomize.vue?vue&type=template&id=18a1b070&scoped=true&"
import script from "./AudioCustomize.vue?vue&type=script&lang=js&"
export * from "./AudioCustomize.vue?vue&type=script&lang=js&"
import style0 from "./AudioCustomize.vue?vue&type=style&index=0&id=18a1b070&lang=less&scoped=true&"
import style1 from "./AudioCustomize.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a1b070",
  null
  
)

export default component.exports